import React, { Component } from "react";
import Select from "react-select";
import Rodal from "rodal";

import CalculateEarnedLeavesWarningDialog from "./CalculateEarnedLeavesWarningDialog";
import ConfirmAndSaveButton from "./ConfirmAndSaveButton";

export default class CalculateEarnedLeavesButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLeaveCategory: { value: 5, label: "Earned Leave" },
      leaveCategory: 5,
      isDialogVisible: false,
    };
  }

  showDialog = () => {
    this.setState({
      isDialogVisible: true,
    });
  };

  hideDialog = () => {
    this.setState({
      isDialogVisible: false,
    });
  };

  get allowedCarryForwardLeaveCategoriesDropDownList() {
    return this.props.leaveCategories
      .filter((leaveCategory) => {
        return !!leaveCategory.allow_carry_forward;
      })
      .map((leaveCategory) => {
        return {
          value: leaveCategory.leave_category_id,
          label: leaveCategory.leave_category,
        };
      });
  }

  handleLeaveCategory(event) {
    this.setState({
      selectedLeaveCategory: event,
      leaveCategory: event.value,
    });
  }

  handleCalculate() {
    if (this.props.outstandingEarnedLeavesCount !== 0) {
      return this.showDialog();
    }
    this.props.calculate(this.state.leaveCategory);
  }

  render() {
    return (
      <div>
        <Rodal
          width={800}
          height={613}
          visible={this.state.isDialogVisible}
          onClose={this.hideDialog}
        >
          <CalculateEarnedLeavesWarningDialog hideDialog={this.hideDialog} />
        </Rodal>
        <div
          style={{
            marginLeft: "10px",
            marginRight: "10px",
            marginBottom: "50px",
          }}
        >
          <div className="row">
            <div className="row col-lg-12">
              <div className="col-sm-3">
                <Select
                  options={this.allowedCarryForwardLeaveCategoriesDropDownList}
                  value={this.state.selectedLeaveCategory} // Previous Year
                  onChange={this.handleLeaveCategory.bind(this)}
                  className="react-select-container checkValidate"
                  classNamePrefix="react-select"
                />
              </div>
              <div className="col-sm-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleCalculate.bind(this)}
                  disabled={this.props.disableCalculate}
                >
                  Calculate
                </button>
              </div>
              {this.props.confirmAndSave && (
                <ConfirmAndSaveButton
                  confirmAndSave={this.props.confirmAndSave}
                  disableSave={this.props.disableSave}
                  currentLeaveCarryYears={this.props.currentLeaveCarryYears}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
